export default __webpack_public_path__ + "static/media/polygons-no-3.1ab123b4.ogg";